import { ICreditDataTableProps, IRightColumnItem } from './types';
import { Grid, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { CustomListItem } from 'components/common';

export const CreditDataTable: FC<ICreditDataTableProps> = ({
  startDate,
  lastUpdateDate,
  fixedPaymentTerms,
  paymentAmount,
  paymentFrequency,
  currentBalance,
  dateOfBirth,
  defaultBalance,
  endDate,
  startBalance,
}) => {
  const rightColumnItems: IRightColumnItem[] = [
    { messageId: 'common.dateOfBirth', variable: dateOfBirth },
    { messageId: 'common.defaultDate', variable: endDate },
    { messageId: 'common.endDate', variable: endDate },
    { messageId: 'common.startBalanceCreditLimit', variable: startBalance },
    { messageId: 'common.defaultDelinquentBalance', variable: defaultBalance },
    { messageId: 'common.currentBalance', variable: currentBalance },
  ];

  return (
    <Grid container rowSpacing={4.5} columnSpacing={2.75}>
      <Grid item xs={12} md={6} lg={6}>
        <List className={'w-full'}>
          <ListItem divider>
            <CustomListItem>
              <FormattedMessage id={'credit.match'} tagName={'div'} />
              <FormattedMessage id={'credit.applicant'} tagName={'div'} />
            </CustomListItem>
          </ListItem>
          <ListItem divider>
            <CustomListItem>
              <FormattedMessage id={'common.startDate'} tagName={'div'} />
              <Typography component={'div'}>{startDate || <FormattedMessage id={'common.noDataFound'} />}</Typography>
            </CustomListItem>
          </ListItem>
          <ListItem divider>
            <CustomListItem>
              <FormattedMessage id={'common.updateDate'} tagName={'div'} />
              <Typography component={'span'}>
                {lastUpdateDate || <FormattedMessage id={'common.noDataFound'} />}
              </Typography>
            </CustomListItem>
          </ListItem>
          <ListItem divider>
            <CustomListItem>
              <FormattedMessage id={'common.creditTerms'} tagName={'div'} />
              <Typography component={'span'}>
                {fixedPaymentTerms && paymentAmount && paymentFrequency ? (
                  `${fixedPaymentTerms} @ £${paymentAmount} (${paymentFrequency})`
                ) : (
                  <FormattedMessage id={'common.noDataFound'} />
                )}
              </Typography>
            </CustomListItem>
          </ListItem>
          <ListItem divider>
            <CustomListItem>
              <FormattedMessage id={'common.paymentAmount'} tagName={'div'} />
              <Typography component={'span'}>
                {paymentAmount || <FormattedMessage id={'common.noDataFound'} />}
              </Typography>
            </CustomListItem>
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List className={'w-full'}>
          {rightColumnItems.map(({ messageId, variable }, index) => (
            <ListItem divider key={index}>
              <CustomListItem>
                <FormattedMessage id={messageId} tagName={'div'} />
                <Typography component={'span'}>{variable || <FormattedMessage id={'common.noDataFound'} />}</Typography>
              </CustomListItem>
            </ListItem>
          ))}
        </List>
      </Grid>
    </Grid>
  );
};
